import { FunctionComponent } from 'react'
import { Modal } from 'react-bootstrap'

import adminCss from '../style.module.scss'

const BiPreviewModal: FunctionComponent<{
  show: boolean
  url: string
  onClose: () => void
}> = ({ show, url, onClose }) => (
  <Modal show={show} onHide={onClose} fullscreen>
    <Modal.Header closeButton>
      <Modal.Title>Preview Bi Médico</Modal.Title>
    </Modal.Header>
    <Modal.Body className={adminCss.biPreviewModalBody}>
      <div className={adminCss.biPreviewFrameWrap}>
        <iframe
          title="Preview Bi Médico"
          src={url}
          className={adminCss.biPreviewModalFrame}
          allowFullScreen
        />
        <div className={adminCss.biBrandCover} aria-hidden="true" />
      </div>
    </Modal.Body>
  </Modal>
)

export default BiPreviewModal
